<template>
  <div>
    <!-- Page Header -->
    <v-card class="mb-6 rounded-lg elevation-3">
      <v-sheet
        color="primary"
        dark
        class="pa-3"
      >
        <v-row align="center" no-gutters>
          <v-col>
            <div class="d-flex align-center">
              <v-icon size="32" class="mr-3">mdi-account-group</v-icon>
              <h2 class="text-h5 font-weight-medium mb-0 mt-0">Quản lý khách hàng</h2>
            </div>
          </v-col>
          <v-col class="text-right">
            <v-chip
              color="white"
              text-color="primary"
              class="font-weight-bold"
            >
              <v-icon left small>mdi-account-multiple</v-icon>
              {{totalItems}} khách hàng
            </v-chip>
          </v-col>
        </v-row>
      </v-sheet>
    </v-card>

    <!-- Main Content Area -->
    <v-card class="rounded-lg elevation-3">
      <v-card-title class="py-4">
        <v-row align="center">
          <v-col cols="12" md="2">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Tên/SĐT/Email"
              hide-details
              outlined
              dense
              clearable
              class="search-field"
              @keyup.enter="fetchListCustomers()"
            ></v-text-field>
          </v-col>
          
          <v-col cols="12" md="2">
            <v-select
              v-model="healthNeedFilter"
              :items="healthNeedsList"
              label="Nhu cầu sức khỏe"
              prepend-inner-icon="mdi-heart-pulse"
              outlined
              dense
              clearable
              hide-details
              class="search-field"
              placeholder="Lọc theo nhu cầu"
            ></v-select>
          </v-col>

          <v-col cols="12" md="2">
            <v-select
              v-model="customerGroupFilter"
              :items="customerGroupOptions"
              label="Nhóm khách hàng"
              prepend-inner-icon="mdi-account-group"
              outlined dense clearable hide-details class="search-field"
              @change="onCareHistoryFilterChange"
            ></v-select>
          </v-col>

          <v-col cols="12" md="2">
            <v-select
              v-model="careStatusFilter"
              :items="activeCareStatusOptions"
              item-text="text"
              item-value="value"
              label="Trạng thái chăm sóc"
              prepend-inner-icon="mdi-account-heart"
              outlined
              dense
              clearable
              hide-details
              class="search-field"
              @change="onCareHistoryFilterChange"
            ></v-select>
          </v-col>

          <v-col cols="12" md="2">
            <v-select
              v-model="feedbackStatusFilter"
              :items="activeFeedbackStatusOptions"
              item-text="text"
              item-value="value"
              label="Trạng thái phản hồi"
              prepend-inner-icon="mdi-message-reply-text"
              outlined dense clearable hide-details class="search-field"
              @change="onCareHistoryFilterChange"
            ></v-select>
          </v-col>

          <v-col cols="12" md="2">
            <v-text-field
              v-model="careDateFrom"
              type="date"
              label="Chăm sóc từ ngày"
              prepend-inner-icon="mdi-calendar-start"
              outlined dense clearable hide-details class="search-field"
              @change="onCareHistoryFilterChange"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="2">
            <v-text-field
              v-model="careDateTo"
              type="date"
              label="Chăm sóc đến ngày"
              prepend-inner-icon="mdi-calendar-end"
              outlined dense clearable hide-details class="search-field"
              @change="onCareHistoryFilterChange"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field
              v-model="reminderDateFilter"
              type="date"
              label="Lịch nhắc hẹn ngày"
              prepend-inner-icon="mdi-calendar-clock"
              outlined
              dense
              clearable
              hide-details
              class="search-field"
              @change="onReminderDateFilterChange"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="1">
            <v-btn
              icon
              @click="fetchListCustomers()"
              class="search-field"
              color="primary"
            >
              <v-icon>mdi-filter-variant</v-icon>
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" class="d-flex justify-end">
            <v-btn
              color="success"
              outlined
              @click="openImportDialog = true"
              class="px-4 mr-3 font-weight-medium text-none rounded-lg"
            >
              <v-icon left>mdi-file-excel</v-icon>
              Nhập Excel
            </v-btn>
            <v-btn
              color="success"
              dark
              @click="exportCustomers"
              class="px-4 mr-3 font-weight-medium text-none rounded-lg"
              elevation="2"
              :loading="exportLoading"
            >
              <v-icon left>mdi-file-export</v-icon>
              Xuất danh sách
            </v-btn>
            <v-btn
              color="primary"
              dark
              @click="openDialog = !openDialog"
              class="px-4 font-weight-medium text-none rounded-lg"
              elevation="2"
            >
              <v-icon left>mdi-account-plus</v-icon>
              Thêm khách hàng mới
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Stats Summary -->
      <v-card-text class="pa-0">
        <v-row class="ma-0">
          <v-col cols="12" sm="4" class="pa-3">
            <v-card outlined class="rounded-lg">
              <v-card-text class="d-flex align-center">
                <v-avatar color="primary lighten-5" size="52" class="mr-4">
                  <v-icon color="primary" size="28">mdi-cash-multiple</v-icon>
                </v-avatar>
                <div>
                  <div class="text-overline grey--text">Tổng dư nợ</div>
                  <div class="text-h6 font-weight-bold">
                    {{formatCurrency(getTotalDebt())}}
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" class="pa-3">
            <v-card outlined class="rounded-lg">
              <v-card-text class="d-flex align-center">
                <v-avatar color="green lighten-5" size="52" class="mr-4">
                  <v-icon color="green" size="28">mdi-account-plus</v-icon>
                </v-avatar>
                <div>
                  <div class="text-overline grey--text">Khách hàng mới</div>
                  <div class="text-h6 font-weight-bold">
                    {{ getNewCustomersCount() }} <span class="text-caption grey--text">trong tháng</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" class="pa-3">
            <v-card outlined class="rounded-lg">
              <v-card-text class="d-flex align-center">
                <v-avatar color="amber lighten-5" size="52" class="mr-4">
                  <v-icon color="amber darken-2" size="28">mdi-cart-outline</v-icon>
                </v-avatar>
                <div>
                  <div class="text-overline grey--text">Giao dịch gần đây</div>
                  <div class="text-h6 font-weight-bold">
                    {{ getRecentTransactions() }} <span class="text-caption grey--text">trong tuần</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Data Table -->
      <v-sheet v-if="isAdminUser" color="blue lighten-5" class="px-4 py-3 bulk-assign-bar">
        <v-row align="center" dense>
          <v-col cols="12" md="3">
            <div class="font-weight-medium primary--text">
              <v-icon left color="primary">mdi-checkbox-marked-circle</v-icon>
              {{ selectedCustomers.length ? `Đã chọn ${selectedCustomers.length} khách hàng` : 'Chưa chọn khách hàng' }}
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="bulkSaleId"
              :items="saleTabs"
              item-text="sale_name"
              item-value="user_id"
              label="Chọn sale nhận data"
              prepend-inner-icon="mdi-account-tie"
              outlined dense hide-details
              :disabled="!selectedCustomers.length"
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-btn color="primary" :loading="bulkAssignLoading" :disabled="!bulkSaleId || !selectedCustomers.length" @click="assignSelectedCustomers">
              <v-icon left>mdi-account-switch</v-icon>Chia data cho sale
            </v-btn>
          </v-col>
          <v-col cols="12" md="2" class="text-right">
            <v-btn text color="grey" :disabled="!selectedCustomers.length" @click="selectedCustomers = []">Bỏ chọn</v-btn>
          </v-col>
        </v-row>
      </v-sheet>
      <v-data-table
        :headers="headers"
        :items="listCustomers"
        v-model="selectedCustomers"
        :show-select="isAdminUser"
        item-key="id"
        :search="search"
        :items-per-page="perPage"
        :server-items-length="totalItems"
        v-model:options="tableOptions"
        loading-text="Đang tải dữ liệu..."
        sort-by="stt"
        class="elevation-0 custom-data-table"
        fixed-header
        :loading="tableLoading"
        :item-class="getCustomerRowClass"
        :footer-props="{
          'items-per-page-text': 'Số bản ghi mỗi trang:',
          'items-per-page-options': [10, 20, 50, 100],
          'show-first-last-page': true,
          'show-current-page': true,
          'first-icon': 'mdi-page-first',
          'last-icon': 'mdi-page-last',
          'prev-icon': 'mdi-chevron-left',
          'next-icon': 'mdi-chevron-right'
        }"
        @click:row="openCareLog"
        @input="handleCustomerSelection"
        @item-selected="handleCustomerItemSelected"
        @toggle-select-all="handleCustomerSelectAll"
        @update:options="updateDisplayedItems"
      >
        <template v-slot:item.stt="{ item }">
          <div class="font-weight-medium">{{getItemNumber(item)}}</div>
        </template>

        <template v-slot:item.name="{ item }">
          <div class="d-flex align-center">
            <v-avatar size="32" color="primary lighten-5" class="mr-2">
              <span class="primary--text text--darken-1 font-weight-bold">{{getInitials(item.name)}}</span>
            </v-avatar>
            <div>
              <div class="d-flex align-center flex-wrap">
                <v-menu
                  open-on-hover
                  bottom
                  right
                  offset-y
                  :close-delay="150"
                  :open-delay="250"
                  nudge-bottom="8"
                  content-class="customer-care-hover-menu"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      text
                      small
                      color="primary"
                      class="pa-0 font-weight-medium customer-name-btn"
                      @click.stop="openCareLog(item)"
                    >
                      {{item.name}}
                    </v-btn>
                  </template>

                  <v-card class="customer-care-preview" elevation="8">
                    <div class="d-flex align-center justify-space-between customer-care-preview__header">
                      <div>
                        <div class="font-weight-bold">Lịch sử chăm sóc</div>
                        <div class="text-caption grey--text text--darken-1">{{ item.name }}</div>
                      </div>
                      <v-chip x-small color="primary" outlined>
                        {{ Array.isArray(item.care_logs) ? item.care_logs.length : 0 }} lần
                      </v-chip>
                    </div>

                    <v-divider />

                    <div v-if="getCareHistoryPreview(item).length" class="customer-care-preview__body">
                      <div
                        v-for="log in getCareHistoryPreview(item)"
                        :key="log.id"
                        class="customer-care-preview__item"
                      >
                        <div class="d-flex align-center justify-space-between mb-1">
                          <v-chip x-small dark :color="getCareStatusColor(log.status)">
                            {{ getCareStatusText(log.status) }}
                          </v-chip>
                          <span class="text-caption grey--text">{{ formatDate(log.created_at) }}</span>
                        </div>
                        <div class="text-caption font-weight-medium">
                          {{ log.care_type || 'Chăm sóc' }}
                        </div>
                        <div class="text-body-2 customer-care-preview__content">
                          {{ log.content || 'Đã lưu lịch sử chăm sóc' }}
                        </div>
                        <div v-if="log.customer_feedback" class="text-caption grey--text text--darken-1 mt-1">
                          Phản hồi: {{ log.customer_feedback }}
                        </div>
                      </div>
                    </div>

                    <div v-else class="pa-4 text-center grey--text">
                      <v-icon color="grey lighten-1" class="mb-1">mdi-history</v-icon>
                      <div class="text-body-2">Chưa có lịch sử chăm sóc</div>
                    </div>

                    <v-divider />
                    <div class="px-4 py-2 text-caption primary--text text-center font-weight-medium">
                      Nhấn vào tên để xem đầy đủ
                    </div>
                  </v-card>
                </v-menu>
                <v-chip
                  v-if="item.sale_name"
                  x-small
                  outlined
                  color="indigo"
                  class="ml-2 sale-name-chip"
                >
                  <v-icon x-small left>mdi-account-tie</v-icon>
                  {{ item.sale_name }}
                </v-chip>
              </div>
              <div class="text-caption grey--text" v-if="item.email">{{item.email}}</div>
            </div>
          </div>
        </template>

        <template v-slot:item.current_status="{ item }">
          <v-chip
            small
            dark
            :color="getCareStatusColor(getCustomerCareStatus(item))"
            class="font-weight-medium"
          >
            {{ getCareStatusText(getCustomerCareStatus(item)) }}
          </v-chip>
          <div class="text-caption grey--text mt-1" v-if="getLatestCareLog(item)">
            {{ getLatestCareLog(item).care_type || 'Chăm sóc' }} - {{ formatDate(getLatestCareLog(item).created_at) }}
          </div>
        </template>

        <template v-slot:item.care_logs="{ item }">
          <div v-if="getLatestCareLog(item)" class="care-summary">
            <div class="font-weight-medium text-truncate care-summary-line">
              {{ getLatestCareLog(item).content || 'Đã lưu lịch sử chăm sóc' }}
            </div>
            <div class="text-caption grey--text text--darken-1 text-truncate care-summary-line" v-if="getLatestCareLog(item).customer_feedback">
              Phản hồi: {{ getLatestCareLog(item).customer_feedback }}
            </div>
            <v-chip x-small outlined color="primary" class="mt-1">
              {{ item.care_logs.length }} lần chăm sóc
            </v-chip>
          </div>
          <span v-else class="grey--text">Chưa có lịch sử</span>
        </template>

        <template v-slot:item.reminders="{ item }">
          <div v-if="getNextReminder(item)">
            <v-chip
              small
              dark
              :color="getReminderColor(getNextReminder(item))"
              class="font-weight-medium"
            >
              {{ getReminderText(getNextReminder(item)) }}
            </v-chip>
            <div class="text-caption grey--text text--darken-1 mt-1">
              {{ formatDate(getNextReminder(item).reminder_date) }}
            </div>
            <div class="text-caption text-truncate reminder-note" v-if="getNextReminder(item).note">
              {{ getNextReminder(item).note }}
            </div>
          </div>
          <span v-else class="grey--text">Không có nhắc hẹn</span>
        </template>

        <template v-slot:item.phone="{ item }">
          <div class="d-flex align-center">
            <v-icon small color="grey darken-1" class="mr-1">mdi-phone</v-icon>
            {{item.phone || 'N/A'}}
          </div>
        </template>

        <template v-slot:item.address="{ item }">
          <div class="d-flex align-center">
            <v-icon small color="grey darken-1" class="mr-1">mdi-map-marker</v-icon>
            <span class="text-truncate address-cell">{{item.address || 'N/A'}}</span>
          </div>
        </template>

        <template v-slot:item.note="{ item }">
          <div class="d-flex align-center">
            <v-icon small color="grey darken-1" class="mr-1">mdi-note-text</v-icon>
            <v-tooltip bottom v-if="item.note && item.note.length > 30">
              <template v-slot:activator="{ on, attrs }">
                <span class="text-truncate note-cell" v-bind="attrs" v-on="on">
                  {{item.note}}
                </span>
              </template>
              <span>{{item.note}}</span>
            </v-tooltip>
            <span v-else class="text-truncate note-cell">{{item.note || 'N/A'}}</span>
          </div>
        </template>

        <template v-slot:item.health_needs="{ item }">
          <div class="d-flex align-center">
            <v-icon small color="grey darken-1" class="mr-1">mdi-heart-pulse</v-icon>
            <div v-if="item.health_needs && item.health_needs.length > 0">
              <v-chip
                v-for="(need, index) in item.health_needs.slice(0, 2)"
                :key="index"
                x-small
                color="primary"
                outlined
                class="mr-1 mb-1"
              >
                {{ need }}
              </v-chip>
              <v-tooltip bottom v-if="item.health_needs.length > 2">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    x-small
                    color="grey"
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  >
                    +{{ item.health_needs.length - 2 }}
                  </v-chip>
                </template>
                <div>
                  <div v-for="(need, index) in item.health_needs.slice(2)" :key="index">
                    {{ need }}
                  </div>
                </div>
              </v-tooltip>
            </div>
            <span v-else class="grey--text">N/A</span>
          </div>
        </template>

        <template v-slot:item.total_money="{ item }">
          <div class="font-weight-medium" :class="{'red--text': item.total_money > 50000000}">
            {{formatCurrency(item.debt)}}
          </div>
        </template>

        <template v-slot:item.updated_at="{ item }">
          <div class="d-flex align-center">
            <v-icon small color="grey darken-1" class="mr-1">mdi-calendar-clock</v-icon>
            {{formatDate(item.updated_at)}}
          </div>
        </template>

        <template v-slot:item.action="{ item }">
          <v-menu
            offset-y
            left
            transition="slide-y-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click.stop
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="editCustomer(item)">
                <v-list-item-icon>
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Chỉnh sửa</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="deleteCustomer(item)">
                <v-list-item-icon>
                  <v-icon color="error">mdi-delete</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="error--text">Xóa</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:no-data>
          <div class="pa-8 text-center">
            <v-icon size="64" color="grey lighten-1" class="mb-4">mdi-account-group-outline</v-icon>
            <div class="text-subtitle-1 grey--text text--darken-1">Chưa có khách hàng nào</div>
            <v-btn
              color="primary"
              class="mt-4"
              outlined
              @click="openDialog = true"
            >
              <v-icon left>mdi-account-plus</v-icon>
              Thêm khách hàng mới
            </v-btn>
          </div>
        </template>

        <template v-slot:progress>
          <v-progress-linear
            color="primary"
            indeterminate
            absolute
            top
          ></v-progress-linear>
        </template>
      </v-data-table>
    </v-card>

    <!-- Create and Update Dialogs -->
    <createCustomer
      :open="openDialog"
      :is-admin-user="isAdminUser"
      :sale-tabs="saleTabs"
      @toggle="openDialog = !openDialog"
      @refresh="handleCustomerRefresh"
    />
    <UpdateCustomer
      :open="openDialogUpdate"
      @toggle="openDialogUpdate = !openDialogUpdate"
      :customer="selectedCustomer"
      :is-admin-user="isAdminUser"
      :sale-tabs="saleTabs"
      @refresh="handleCustomerRefresh"
    />
    <CareLogCustomer
      :open="openCareLogDialog"
      :customer="selectedCareCustomer"
      :statuses="careStatuses"
      :feedback-statuses="feedbackStatuses"
      :care-methods="careMethods"
      @toggle="handleCareDialogToggle"
      @refresh="handleCareRefresh"
    />
    <ImportCustomerOrders
      :open="openImportDialog"
      @toggle="openImportDialog = false"
      @refresh="handleCustomerRefresh"
    />

    <!-- Delete Confirmation Dialog -->
    <v-dialog
      v-model="deleteDialog"
      max-width="400"
      persistent
    >
      <v-card class="rounded-lg">
        <v-card-title class="headline error--text">
          <v-icon left color="error" size="24">mdi-alert-circle</v-icon>
          Xác nhận xóa
        </v-card-title>
        <v-card-text class="py-3">
          <p class="text-subtitle-1">Bạn có chắc chắn muốn xóa khách hàng <strong>{{ customerToDelete?.name }}</strong>?</p>
          <p class="text-body-2 grey--text text--darken-1 mt-2">
            Hồ sơ, lịch sử chăm sóc và lịch nhắc sẽ bị xóa vĩnh viễn. Đơn hàng cũ vẫn được giữ lại dưới dạng khách lẻ. Hành động này không thể hoàn tác.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey darken-1"
            @click="cancelDelete"
            :disabled="deleteLoading"
          >
            Hủy bỏ
          </v-btn>
          <v-btn
            color="error"
            :loading="deleteLoading"
            @click="confirmDelete"
            elevation="2"
            class="px-4"
          >
            <v-icon left>mdi-delete</v-icon>
            Xóa
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import createCustomer from '@/components/Dialogs/Customers/Create.vue'
import UpdateCustomer from '@/components/Dialogs/Customers/Update.vue'
import CareLogCustomer from '@/components/Dialogs/Customers/CareLog.vue'
import ImportCustomerOrders from '@/components/Dialogs/Customers/ImportOrders.vue'
import customerModule from '@/api/customers'
import authModule from '@/api/auth'
const customerActions = customerModule.actions
const authActions = authModule.actions

const CUSTOMER_LIST_STATE_KEY = 'customerListState'

function getSavedCustomerListState() {
  try {
    return JSON.parse(sessionStorage.getItem(CUSTOMER_LIST_STATE_KEY) || '{}')
  } catch (error) {
    return {}
  }
}

export default {
  components: {
    createCustomer,
    UpdateCustomer,
    CareLogCustomer,
    ImportCustomerOrders
  },
  data() {
    const savedListState = getSavedCustomerListState()
    const savedPage = Math.max(1, Number(savedListState.page) || 1)
    const savedPerPage = Number(savedListState.perPage) || 10

    return {
      tableOptions: {
        page: savedPage,
        itemsPerPage: savedPerPage
      },
      search: '',
      healthNeedFilter: null,
      customerGroupFilter: null,
      customerGroupOptions: [
        { text: 'Khách hàng mới', value: 'new' },
        { text: 'Khách hàng cũ', value: 'old' }
      ],
      careStatusFilter: null,
      feedbackStatusFilter: null,
      careDateFrom: '',
      careDateTo: '',
      reminderDateFilter: '',
      healthNeedsList: [
        'Xương khớp',
        'Tiểu đường',
        'Tăng cân',
        'Giảm cân',
        'Con cần dinh dưỡng',
        'Tiêu hóa'
      ],
      careStatuses: [],
      feedbackStatuses: [],
      careMethods: [],
      tableLoading: false,
      exportLoading: false,
      currentUserLocal: null,
      saleTabs: [],
      selectedCustomers: [],
      bulkSaleId: null,
      bulkAssignLoading: false,
      // Pagination parameters
      page: savedPage,
      perPage: savedPerPage,
      totalItems: 0,
      highlightedCustomerId: savedListState.highlightedCustomerId || null,
      headers: [
        { text: 'STT', value: 'stt', width: '70px' },
        { text: 'Tên khách hàng', value: 'name', width: '220px' },
        { text: 'Số điện thoại', value: 'phone', width: '150px' },
        //{ text: 'Email', value: 'email', width: '180px' },
        { text: 'Địa chỉ', value: 'address' },
        { text: 'Thông tin chi tiết', value: 'note', width: '200px' },
        { text: 'Nhu cầu sức khỏe', value: 'health_needs', width: '250px' },
        { text: 'Trạng thái CSKH', value: 'current_status', width: '180px' },
        { text: 'Lịch sử gần nhất', value: 'care_logs', sortable: false, width: '260px' },
        { text: 'Nhắc hẹn', value: 'reminders', sortable: false, width: '190px' },
        // { text: 'Công nợ', value: 'total_money', width: '150px'},
        { text: 'Cập nhật lúc', value: 'updated_at', width: '180px'},
        { text: '', value: 'action', sortable: false, width: '70px', align: 'center' },
      ],
      openDialog: false,
      openDialogUpdate: false,
      openCareLogDialog: false,
      openImportDialog: false,
      listCustomers: [],
      selectedCustomer: {},
      selectedCareCustomer: {},

      // Delete dialog data
      deleteDialog: false,
      customerToDelete: null,
      deleteLoading: false
    }
  },
  computed: {
    activeCareStatusOptions() {
      return this.careStatuses.filter(status => status.is_active !== false)
    },
    activeFeedbackStatusOptions() {
      return this.feedbackStatuses.filter(status => status.is_active !== false)
    },
    currentUser() {
      const vuexUser = this.normalizeUser(this.$store?.getters?.currentUser);
      if (vuexUser?.id || vuexUser?.user_id) return vuexUser;

      const localUser = this.normalizeUser(JSON.parse(localStorage.getItem('user_info') || '{}'));
      if (localUser?.id || localUser?.user_id) return localUser;

      return this.normalizeUser(this.currentUserLocal);
    },

    currentUserId() {
      return Number(this.currentUser?.id || this.currentUser?.user_id || 0);
    },

    isAdminUser() {
      return Number(this.currentUser?.type) === 1;
    },

  },
  methods: {
    handleCustomerSelection(items) {
      this.selectedCustomers = Array.isArray(items) ? [...items] : [];
    },

    handleCustomerItemSelected({ item, value }) {
      const selected = new Map(this.selectedCustomers.map(customer => [Number(customer.id), customer]));
      if (value) selected.set(Number(item.id), item);
      else selected.delete(Number(item.id));
      this.selectedCustomers = Array.from(selected.values());
    },

    handleCustomerSelectAll({ items, value }) {
      this.selectedCustomers = value && Array.isArray(items) ? [...items] : [];
    },

    assignSelectedCustomers() {
      if (!this.bulkSaleId || !this.selectedCustomers.length) return;
      this.bulkAssignLoading = true;
      customerActions.bulkAssign({
        customer_ids: this.selectedCustomers.map(customer => customer.id),
        sale_id: this.bulkSaleId
      }).then(response => {
        const updated = Number(response.data?.data?.updated || this.selectedCustomers.length);
        this.$snackbar.success(`Đã chia ${updated} khách hàng cho sale`);
        this.selectedCustomers = [];
        this.bulkSaleId = null;
        return this.handleCustomerRefresh();
      }).catch(error => {
        this.$snackbar.error(error.response?.data?.message || 'Không thể chia data cho sale');
      }).finally(() => {
        this.bulkAssignLoading = false;
      });
    },
    fetchCareStatuses() {
      return Promise.all([
        customerActions.getCareStatuses('care'),
        customerActions.getCareStatuses('feedback'),
        customerActions.getCareStatuses('method')
      ]).then(([careResponse, feedbackResponse, methodResponse]) => {
          this.careStatuses = (careResponse.data?.data || []).map(status => ({ ...status, text: status.name }))
          this.feedbackStatuses = (feedbackResponse.data?.data || []).map(status => ({ ...status, text: status.name }))
          this.careMethods = (methodResponse.data?.data || []).map(method => ({ ...method, text: method.name }))
        })
        .catch(() => this.$snackbar.error('Không thể tải trạng thái chăm sóc'))
    },
    normalizeUser(user) {
      if (!user || typeof user !== 'object') return {};
      if (user.data && typeof user.data === 'object') return user.data;
      if (user.user && typeof user.user === 'object') return user.user;
      return user;
    },

    fetchCurrentUser() {
      if (this.currentUserId) return Promise.resolve();

      return authActions.getAccountInfo()
        .then(res => {
          const user = this.normalizeUser(res.data?.data || res.data);
          this.currentUserLocal = user;

          if (user?.id || user?.user_id) {
            localStorage.setItem('user_info', JSON.stringify(user));
            if (this.$store && typeof this.$store.commit === 'function') {
              this.$store.commit('SET_USER', user);
            }
          }

          this.syncSaleTabs(this.listCustomers);
        })
        .catch(error => {
          console.error('Error loading current user:', error);
        });
    },

    getCustomerResponseData(response) {
      const customers = response.data?.data || [];

      return {
        customers,
        total: response.data?.meta?.total || customers.length
      };
    },

    getCustomerSearchParams(page = 1, itemsPerPage = 10) {
      const searchParams = {
        search: this.search,
        page,
        per_page: itemsPerPage
      };

      if (this.healthNeedFilter) {
        searchParams.health_need = this.healthNeedFilter;
      }

      if (this.customerGroupFilter) searchParams.customer_group = this.customerGroupFilter;

      if (this.careStatusFilter) searchParams.care_status = this.careStatusFilter;
      if (this.feedbackStatusFilter) searchParams.feedback_status = this.feedbackStatusFilter;
      if (this.careDateFrom) searchParams.care_date_from = this.careDateFrom;
      if (this.careDateTo) searchParams.care_date_to = this.careDateTo;

      if (this.reminderDateFilter) {
        searchParams.reminder_date = this.reminderDateFilter;
      }

      return searchParams;
    },

    onReminderDateFilterChange() {
      this.tableOptions = {
        ...this.tableOptions,
        page: 1
      };
      this.fetchListCustomers(1, this.perPage);
    },

    onCareHistoryFilterChange() {
      this.tableOptions = {
        ...this.tableOptions,
        page: 1
      };
      this.fetchListCustomers(1, this.perPage);
    },

    fetchSaleTabs() {
      if (!this.isAdminUser) return Promise.resolve();

      return customerActions.getCustomers({
        page: 1,
        per_page: 1000
      }).then(res => {
        const { customers } = this.getCustomerResponseData(res);
        this.syncSaleTabs(customers);
      }).catch(error => {
        console.error('Error loading sale tabs:', error);
      });
    },

    updateDisplayedItems(options) {
      // Extract pagination options
      const { itemsPerPage, page, sortBy, sortDesc } = options;

      // Now you can use these values in your API call
      this.fetchListCustomers(page, itemsPerPage, sortBy, sortDesc);
    },
    editCustomer(item) {
      this.selectedCustomer = item;
      this.openDialogUpdate = true;
    },


    handleCustomerRefresh() {
      this.fetchSaleTabs();
      this.fetchListCustomers(this.page, this.perPage);
    },

    syncSaleTabs(customers) {
      if (!this.isAdminUser || !Array.isArray(customers)) return;

      const saleMap = new Map(this.saleTabs.map(sale => [Number(sale.user_id), sale]));

      customers.forEach(customer => {
        if (!customer?.user_id) return;

        const userId = Number(customer.user_id);
        if (!saleMap.has(userId)) {
          saleMap.set(userId, {
            user_id: userId,
            sale_name: customer.sale_name || `Sale #${userId}`
          });
        }
      });

      this.saleTabs = Array.from(saleMap.values()).sort((a, b) => {
        return a.sale_name.localeCompare(b.sale_name, 'vi');
      });

    },

    openCareLog(item) {
      this.selectedCareCustomer = item;
      this.fetchCareStatuses().finally(() => {
        this.openCareLogDialog = true;
      });
    },

    handleCareDialogToggle() {
      this.openCareLogDialog = !this.openCareLogDialog;
      if (!this.openCareLogDialog) this.fetchCareStatuses();
    },

    handleCareRefresh() {
      this.highlightedCustomerId = this.selectedCareCustomer?.id || null;
      this.saveCustomerListState();
      return this.fetchListCustomers(this.page, this.perPage);
    },

    saveCustomerListState() {
      try {
        sessionStorage.setItem(CUSTOMER_LIST_STATE_KEY, JSON.stringify({
          page: this.page,
          perPage: this.perPage,
          highlightedCustomerId: this.highlightedCustomerId
        }));
      } catch (error) {
        // Việc lưu trạng thái chỉ hỗ trợ trải nghiệm, không được chặn tải dữ liệu.
      }
    },

    getCareStatus(status) {
      return this.careStatuses.find(item => Number(item.value) === Number(status)) || {
        text: 'Chưa chăm sóc',
        color: 'grey'
      };
    },

    getSortedByDate(items, dateField) {
      if (!Array.isArray(items)) return [];
      return [...items].sort((a, b) => {
        const dateA = new Date(a?.[dateField] || 0).getTime();
        const dateB = new Date(b?.[dateField] || 0).getTime();
        return dateB - dateA;
      });
    },

    getLatestCareLog(customer) {
      return this.getSortedByDate(customer?.care_logs, 'created_at')[0] || null;
    },

    getCareHistoryPreview(customer) {
      return this.getSortedByDate(customer?.care_logs, 'created_at').slice(0, 3);
    },

    getCustomerCareStatus(customer) {
      return this.getLatestCareLog(customer)?.status || customer?.current_status || null;
    },

    getNextReminder(customer) {
      if (!Array.isArray(customer?.reminders)) return null;

      if (this.reminderDateFilter) {
        return customer.reminders.find(reminder => {
          if (reminder.is_done || (reminder.status && reminder.status !== 'pending')) {
            return false;
          }

          return String(reminder.reminder_date || '').slice(0, 10) === this.reminderDateFilter;
        }) || null;
      }

      const pendingReminders = customer.reminders
        .filter(reminder => !reminder.is_done && (!reminder.status || reminder.status === 'pending'))
        .sort((a, b) => new Date(a.reminder_date || 0) - new Date(b.reminder_date || 0));

      if (pendingReminders.length > 0) {
        return pendingReminders[0];
      }

      return this.getSortedByDate(customer.reminders, 'reminder_date')[0] || null;
    },

    getReminderState(reminder) {
      if (!reminder) return 'none';
      if (reminder.status === 'cancelled') return 'cancelled';
      if (reminder.status === 'completed' || reminder.is_done) return 'done';

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const reminderDate = new Date(reminder.reminder_date);
      reminderDate.setHours(0, 0, 0, 0);

      if (reminderDate < today) return 'overdue';
      if (reminderDate.getTime() === today.getTime()) return 'today';
      return 'upcoming';
    },

    getReminderColor(reminder) {
      const colors = {
        overdue: 'red darken-1',
        today: 'deep-orange',
        upcoming: 'indigo',
        done: 'green',
        cancelled: 'grey',
        none: 'grey'
      };

      return colors[this.getReminderState(reminder)] || colors.none;
    },

    getReminderText(reminder) {
      const labels = {
        overdue: 'Quá hạn',
        today: 'Hôm nay',
        upcoming: 'Sắp tới',
        done: 'Đã xong',
        cancelled: 'Đã hủy',
        none: 'Không có'
      };

      return labels[this.getReminderState(reminder)] || labels.none;
    },

    getCustomerRowClass(customer) {
      const rowClasses = [];

      if (Number(customer?.id) === Number(this.highlightedCustomerId)) {
        rowClasses.push('customer-row-updated');
      }

      const reminderState = this.getReminderState(this.getNextReminder(customer));

      if (reminderState === 'overdue') rowClasses.push('customer-row-overdue');
      else if (reminderState === 'today') rowClasses.push('customer-row-today');
      else if (this.getCustomerCareStatus(customer)) {
        rowClasses.push(`customer-row-status-${this.getCustomerCareStatus(customer)}`);
      }

      return rowClasses.join(' ');
    },

    getCareStatusText(status) {
      return this.getCareStatus(status).text;
    },

    getCareStatusColor(status) {
      return this.getCareStatus(status).color;
    },

    // Delete customer methods
    deleteCustomer(item) {
      this.customerToDelete = item;
      this.deleteDialog = true;
    },

    cancelDelete() {
      this.deleteDialog = false;
      setTimeout(() => {
        this.customerToDelete = null;
      }, 300);
    },

    confirmDelete() {
      if (!this.customerToDelete) return;

      this.deleteLoading = true;

      customerActions.deleteCustomer(this.customerToDelete.id)
        .then(() => {
          this.$snackbar.success('Xóa khách hàng thành công!');
          this.fetchListCustomers();
          this.deleteDialog = false;
        })
        .catch(error => {
          console.error('Delete error:', error);
          this.$snackbar.error('Không thể xóa khách hàng. Vui lòng thử lại.');
        })
        .finally(() => {
          this.deleteLoading = false;
          setTimeout(() => {
            this.customerToDelete = null;
          }, 300);
        });
    },

    init() {
      this.fetchListCustomers();
    },

    fetchListCustomers(page = 1, itemsPerPage = 10, sortBy = [], sortDesc = []) {
      this.tableLoading = true;
      this.selectedCustomers = [];
      this.page = page;
      this.perPage = itemsPerPage;
      this.saveCustomerListState();

      const searchParams = this.getCustomerSearchParams(page, itemsPerPage);

      customerActions.getCustomers(searchParams).then(res => {
        const { customers, total } = this.getCustomerResponseData(res);

        this.listCustomers = customers;
        this.totalItems = total;

        this.syncSaleTabs(customers);
      }).catch(err => {
        this.$snackbar.error('Không thể tải danh sách khách hàng');
        console.error('Error loading customers:', err);
      }).finally(() => {
        this.tableLoading = false;
      });
    },

    getItemNumber(item) {
      const index = this.listCustomers.indexOf(item);
      return ((this.page - 1) * this.perPage) + index + 1;
    },

    formatCurrency(value) {
      if (!value && value !== 0) return '0 ₫';
      return value.toLocaleString('vi-VN', {style: 'currency', currency: 'VND'});
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
      return new Date(dateString).toLocaleDateString('vi-VN', options);
    },

    formatDateOnly(dateString) {
      if (!dateString) return '';
      const [year, month, day] = String(dateString).slice(0, 10).split('-');
      return `${day}/${month}/${year}`;
    },

    // Get initials for avatar
    getInitials(name) {
      if (!name) return 'N/A';
      return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
    },

    // Calculate total debt (for stats card)
    // Note: This is calculating based on the current page only
    // For accurate statistics across all pages, consider adding a dedicated API endpoint
    getTotalDebt() {
      return this.listCustomers.reduce((sum, customer) => sum + (customer.total_money || 0), 0);
    },

    // Get new customers count (for stats card)
    // Note: This is calculating based on the current page only
    // For accurate statistics across all pages, consider adding a dedicated API endpoint
    getNewCustomersCount() {
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

      return this.listCustomers.filter(customer => {
        return customer.created_at && new Date(customer.created_at) > oneMonthAgo;
      }).length;
    },

    // Get recent transactions count (for stats card)
    getRecentTransactions() {
      // This would ideally come from your transactions API
      return Math.floor(Math.random() * 20) + 5;
    },
    
    exportCustomers() {
      this.exportLoading = true;
      
      // Prepare export parameters (can include filters if needed)
      let exportParams = {
        search: this.search
      };

      if (this.healthNeedFilter) {
        exportParams.health_need = this.healthNeedFilter;
      }

      
      customerActions.exportCustomers(exportParams)
        .then(response => {
          // Create a blob from the response data
          const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
          });
          
          // Create a link element and trigger download
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          
          // Set filename from content-disposition header if available, otherwise use default
          const contentDisposition = response.headers['content-disposition'];
          let filename = 'danh-sach-khach-hang.xlsx';
          
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            if (filenameMatch && filenameMatch.length === 2) {
              filename = filenameMatch[1];
            }
          }
          
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          this.$snackbar.success('Xuất danh sách khách hàng thành công!');
        })
        .catch(error => {
          console.error('Export error:', error);
          this.$snackbar.error('Không thể xuất danh sách khách hàng. Vui lòng thử lại.');
        })
        .finally(() => {
          this.exportLoading = false;
        });
    }
  },
  mounted() {
    this.fetchCareStatuses()
    this.fetchCurrentUser()
      .finally(() => {
        this.fetchSaleTabs();
        this.fetchListCustomers(this.page, this.perPage);
      });
  }
}
</script>

<style scoped>
.custom-data-table {
  border: none !important;
}

.custom-data-table >>> .v-data-table__wrapper {
  border-radius: 0 0 8px 8px;
}

.custom-data-table >>> th {
  font-size: 0.875rem !important;
  color: rgba(0, 0, 0, 0.6) !important;
  font-weight: 500 !important;
  background-color: #f5f5f5 !important;
}

.custom-data-table >>> tr:hover {
  background-color: rgba(25, 118, 210, 0.05) !important;
}

.custom-data-table >>> tbody tr {
  cursor: pointer;
}

.custom-data-table >>> tr td {
  border-bottom: thin solid rgba(0, 0, 0, 0.05) !important;
  padding: 12px 16px !important;
}

.search-field >>> .v-input__prepend-inner {
  margin-top: 8px !important;
}

.search-field >>> .v-text-field__slot input {
  font-size: 0.95rem !important;
}

.address-cell {
  max-width: 180px;
  display: inline-block;
}

.note-cell {
  max-width: 800px;
  display: inline-block;
  cursor: pointer;
}

.care-summary-line {
  max-width: 240px;
}

.reminder-note {
  max-width: 170px;
}

.customer-name-btn {
  min-width: 0 !important;
  height: auto !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
}

.customer-name-btn >>> .v-btn__content {
  justify-content: flex-start;
}

.customer-care-preview {
  width: 340px;
  max-width: calc(100vw - 24px);
  overflow: hidden;
}

.customer-care-preview__header {
  padding: 12px 16px;
}

.customer-care-preview__body {
  max-height: 330px;
  overflow-y: auto;
}

.customer-care-preview__item {
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.customer-care-preview__item:last-child {
  border-bottom: 0;
}

.customer-care-preview__content {
  margin-top: 2px;
  line-height: 1.35;
  white-space: normal;
  overflow-wrap: anywhere;
}

.custom-data-table >>> .customer-row-overdue {
  background-color: #ffebee !important;
}

.custom-data-table >>> .customer-row-today {
  background-color: #fff3e0 !important;
}

.custom-data-table >>> .customer-row-status-1 {
  background-color: #e3f2fd !important;
}

.custom-data-table >>> .customer-row-status-2 {
  background-color: #e0f7fa !important;
}

.custom-data-table >>> .customer-row-status-3 {
  background-color: #fff8e1 !important;
}

.custom-data-table >>> .customer-row-status-4 {
  background-color: #fbe9e7 !important;
}

.custom-data-table >>> .customer-row-status-5 {
  background-color: #e8f5e9 !important;
}

.custom-data-table >>> .customer-row-status-6 {
  background-color: #f5f5f5 !important;
}

.custom-data-table >>> .customer-row-updated {
  background-color: #e8f5e9 !important;
  box-shadow: inset 4px 0 0 #2e7d32 !important;
  animation: customer-row-highlight 1.2s ease-in-out 2;
}

.custom-data-table >>> .customer-row-updated td {
  font-weight: 500;
}

@keyframes customer-row-highlight {
  0%, 100% {
    background-color: #e8f5e9;
  }
  50% {
    background-color: #c8e6c9;
  }
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .v-data-table >>> .v-data-table__wrapper {
    overflow-x: auto;
  }
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #1976D2;
}
</style>
